{
    "common": {
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mié",
        "thu": "Jue",
        "fri": "Vie",
        "sat": "Sáb",
        "sun": "Dom",
        "jan": "Ene",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Abr",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ago",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dic",
        "january": "Enero",
        "february": "Febrero",
        "march": "Marzo",
        "april": "Abril",
        "may": "Mayo",
        "june": "Junio",
        "july": "Julio",
        "august": "Agosto",
        "september": "Septiembre",
        "october": "Octubre",
        "november": "Noviembre",
        "december": "Diciembre",
        "checkin": "Llegada",
        "checkout": "Salida",
        "room": "Habitación",
        "rooms": "Habitaciones",
        "adult": "Adulto",
        "adults": "Adultos",
        "edit": "Editar",
        "editCap": "EDITAR",
        "delete": "Eliminar",
        "deleteCap": "ELIMINAR",
        "localTime": "Hora Local",
        "back": "ATRÁS",
        "home": "INICIO",
        "yes": "SÍ",
        "no": "NO",
        "left": "Restante",
        "hour": "Hora",
        "hours": "Horas",
        "night": "noche",
        "nights": "noches",
        "for": "para",
        "why": "Por qué",
        "get": "Obtener",
        "more": "Más",
        "agree": "ACEPTAR",
        "disagree": "RECHAZAR",
        "basedOn": "basado en",
        "error": "Hubo un error, por favor inténtalo de nuevo más tarde",
        "error2": "¡Falló, inténtalo de nuevo!",
        "error3": "¡¡Ocurrió un Error!!",
        "error4": "¡¡Ocurrió un error!! Por favor inténtalo de nuevo",
        "error5": "¡¡Lo sentimos!! Ocurrió algún error. Por favor inténtalo de nuevo después de un tiempo.",
        "hi": "Hola",
        "to": "a",
        "free": "Gratis",
        "per": "Por",
        "at": "en",
        "day": "Día",
        "days": "Días",
        "time": "Tiempo",
        "of": "de",
        "photo": "Foto",
        "photos": "Fotos",
        "done": "Hecho",
        "fullStay": "Estancia Completa",
        "date": "Fecha",
        "and": "y",
        "bookingDetail": "Detalle de Reserva",
        "Back": "Atrás",
        "Home": "Inicio"
    },
    "userPopup": {
        "myAccount": "Mi Cuenta",
        "welcome": "Bienvenido",
        "user": "Usuario",
        "findMyBookings": "ENCONTRAR MIS RESERVAS",
        "viewProfile": "VER PERFIL",
        "makeAReservarion": "HACER UNA RESERVA",
        "logout": "CERRAR SESIÓN",
        "loginCap": "INICIAR SESIÓN",
        "login": "Iniciar Sesión",
        "invalidCredentials": "Credenciales inválidas",
        "invalidEmail": "Email inválido",
        "passwordIsRequired": "Se requiere contraseña",
        "minChar8": "mínimo 8 caracteres",
        "tooShort": "¡Demasiado corto!",
        "tooLong": "¡Demasiado largo!",
        "required": "Requerido",
        "emailInvalid": "Ingresa un email válido",
        "passwordInvalid": "Ingresa una contraseña válida",
        "phNumInvalid": "El número de teléfono no es válido",
        "signupCap": "REGISTRARSE",
        "signup": "Registrarse",
        "verifyText": "Verifica que eres tú",
        "verifyText2": "Enviamos un código de verificación a tu email",
        "verificationCode": "Código de Verificación",
        "didNotReceiveEmail": "No recibiste el email",
        "clickToResend": "Haz clic para reenviar",
        "verifyAndSignIn": "Verificar e Iniciar Sesión",
        "otpSentSuccessfully": "OTP enviado exitosamente",
        "somethingWentWrong": "Algo salió mal, por favor inténtalo de nuevo",
        "otpError": "Por favor ingresa un número válido",
        "otpError2": "Por favor ingresa solo números",
        "otpError3": "OTP incorrecto, por favor inténtalo de nuevo",
        "otpError4": "OTP Expirado, haz clic en Reenviar para intentar de nuevo",
        "otpError5": "Por favor inténtalo de nuevo",
        "forgetPassword": "Olvidé mi Contraseña",
        "submitError": "¡El usuario no existe!",
        "userExistError": "El Usuario Ya Existe",
        "checkYourEmail": "Revisa tu email",
        "passwordResetLinkSent": "Hemos enviado un enlace de restablecimiento de contraseña a",
        "noWorriesResetInstructions": "No te preocupes, te enviaremos instrucciones de restablecimiento.",
        "enterYourEmail": "Ingresa tu email",
        "resetMyPassword": "RESTABLECER MI CONTRASEÑA",
        "setANewPassword": "Establecer una nueva contraseña",
        "newPassword": "Nueva Contraseña",
        "confirmPassword": "Confirmar Contraseña",
        "confirmPasswordError": "Las contraseñas deben coincidir",
        "backToLogin": "Volver al Inicio de Sesión",
        "dontHaveAccount": "¿No tienes una cuenta?",
        "alreadyHaveAccount": "¿Ya tienes una cuenta?",
        "memberDiscount1": "Obtendrás",
        "memberDiscount2": "descuento de miembro para siempre.",
        "discount1": "Gestiona todas tus reservas desde un solo lugar.",
        "discount2": "¡¡Regístrate para recomendaciones personalizadas y experiencias a medida!!",
        "discount3": "Únete a nuestra comunidad de huéspedes felices y comienza a planificar tu estadía.",
        "leftGridText1": "Gestiona todas tus reservas desde un solo lugar",
        "leftGridText2": "¡¡Regístrate para recomendaciones personalizadas y experiencias a medida!!",
        "leftGridText3": "Únete a nuestra comunidad de huéspedes felices y comienza a planificar tu estadía",
        "gridDiscountText1": "descuento de miembro en",
        "gridDiscountText2": "propiedades seleccionadas para siempre",
        "gridDiscountText3": "Inicia sesión para una experiencia a medida para siempre",
        "gridDiscountText4": "Obtén Beneficios Exclusivos de Miembro",
        "findBookingError": "Tu email e ID de reserva no coinciden",
        "verifyAndConfirmBooking": "Verificar y confirmar reserva",
        "confirmEmailText": "Hemos enviado un código de verificación a tu dirección de email",
        "enterCodeText": "Por favor ingresa el código de verificación enviado a ti",
        "didNotRecieveEmail": "¿No recibiste el email?",
        "changeEmailText": "Haz clic aquí para cambiar la dirección de email",
        "verifyAndConfirm": "Verificar y Confirmar",
        "verified": "VERIFICADO",
        "bookingExpired": "Reserva Expirada",
        "bookingExpiredText": "Lo sentimos, el ID de reserva que estás usando expiró",
        "backToFindingBooking": "Volver a Buscar Reserva",
        "findMyBooking": "Encontrar Mis Reservas",
        "bookingEmail": "Email de Reserva",
        "reservationId": "ID de Reserva",
        "findBooking": "BUSCAR RESERVA",
        "abandonmentCartDoneText1": "¡Gracias!",
        "abandonmentCartDoneText2": "Los detalles de tu carrito han sido enviados al email. Continúa tu reserva en cualquier momento.",
        "Recommended Currencies": "Monedas Recomendadas",
        "All currencies": "Todas las monedas",
        "thisIsRequiredField": "Este es un campo requerido"
    },
    "widget": {
        "destination": "Destino",
        "enterDestination": "Ingresa Destino",
        "guests": "Huéspedes",
        "nationality": "Nacionalidad",
        "selectNationality": "Seleccione la nacionalidad",
        "nationalityIsRequired": "La nacionalidad es obligatoria",
        "selectedRate": "Tarifa especial",
        "search": "Buscar",
        "ages": "Edades",
        "orAbove": "O Mayor",
        "child": "Niño",
        "children": "Niños",
        "addAnotherRoom": "Agregar Otra Habitación",
        "removeRoom": "Eliminar Habitación",
        "property": "Propiedad",
        "city": "Ciudad",
        "country": "País",
        "bookNow": "Reservar Ahora",
        "overnightStay": "Estancia Nocturna",
        "dayUse": "Uso Diurno",
        "destinationIsRequired": "El destino es requerido",
        "checkInIsRequired": "La fecha de llegada es requerida",
        "checkOutIsRequired": "La fecha de salida es requerida",
        "noLocationFound": "No se Encontró Ubicación",
        "soldOut": "Agotado",
        "highDemand": "Alta Demanda",
        "dates": "Fechas",
        "allRates": "Todas las tarifas están en",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Check-out el mismo día"
    },
    "promotion": {
        "headingText": "Información Importante para",
        "regularRate": "Ninguno",
        "seniorCitizen": "Tarifa de Adulto Mayor",
        "agencyRate": "Tarifa de Agencia",
        "caaRate": "Tarifa CAA/AAA",
        "corporateRate": "Tarifa Corporativa",
        "governmentRate": "Tarifa Gubernamental/Militar",
        "promotionalSpecialRate": "Tarifa Promocional/Especial",
        "regularRateDescription": "No se aplicó ninguna promoción.",
        "seniorCitizenRateDescription": "Esta es una tarifa de hotel con descuento ampliamente disponible para adultos mayores, típicamente de 60 años o más.",
        "agencyRateDescription": "Esta es una tarifa de hotel con descuento que puede ser accedida únicamente a través de agentes de viajes específicos fomentando la asociación y colaboración.",
        "caaRateDescription": "Esta es una tarifa especial de hotel ofrecida a miembros de AAA o CAA para ahorros exclusivos.",
        "corporateRateDescription": "Esta es una tarifa de hotel con descuento extendida a viajeros de negocios, típicamente negociada entre el hotel y la entidad corporativa.",
        "governmentRateDescription": "Este plan de tarifas ofrece descuentos específicos para personal gubernamental/militar para reservar una habitación de hotel.",
        "contentSeniorCitizen": "La prueba de fecha de nacimiento es obligatoria al momento del check-in. La falta de presentación de identificación relevante resultará en el cobro de tarifas vigentes.",
        "contentAgencyRate": "Asegúrate de tener tu confirmación de reserva y prueba de identidad al llegar. La falta de presentación de estos resultará en la aplicación de tarifas estándar.",
        "contentPromotionalSpecialRate": "Esta es una tarifa de hotel con descuento ofrecida por tiempo limitado, a menudo vinculada a eventos específicos, temporadas o campañas de marketing.",
        "contentCaaRate": "Por favor asegúrate de tener tu tarjeta de membresía CAA o identificación relevante al momento del check-in. La falta de presentación de identificación relevante resultará en el cobro de tarifas vigentes.",
        "contentCorporateRate": "Se requiere prueba de identificación de empresa u otra documentación oficial al momento del check-in. La falta de presentación de prueba relevante resultará en el cobro de tarifas vigentes.",
        "contentGovernmentRate": "Se debe proporcionar identificación gubernamental o militar válida al momento del check-in. La falta de proporcionar la identificación requerida resultará en cargos a la tarifa estándar.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "APLICAR",
        "Offer Code": "Código de Oferta",
        "Agency Code": "Código de Agencia",
        "Corporate Code": "Código Corporativo",
        "All-Access Rate": "Tarifa de Acceso Total",
        "errorCode": "Este código no es válido"
    }
} 